var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex flex-col space-y-2",class:{
    'nested-group transition-all duration-150': _vm.isExpanded && !_vm.loading
  }},[_vm._t("collapsed",null,{"toggleItems":_vm.toggleItems,"isExpanded":_vm.isExpanded}),_vm._v(" "),(_vm.isExpanded && !_vm.loading)?[_vm._t("expanded")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }